export const TradeMessageType = {
  USER: "ALL",
  SYSTEM: "SYSTEM",
  ADMIN: "ADMIN",
} as const;

export type TradeMessageType =
  (typeof TradeMessageType)[keyof typeof TradeMessageType];

export interface TradeMessage {
  id?: string | undefined;
  tradeId?: string | null;
  senderId: string | null;
  message?: string | null;
  systemBuyerMessage?: string | null;
  systemSellerMessage?: string | null;
  imageUrl?: string | null;
  type: TradeMessageType;
  createdAt: string;
  updatedAt?: string;
  senderRole: string | null;
}

export interface TradeMessageResponse {
  id?: string;
  tradeId: string;
  senderId: string;
  message: string;
  systemBuyerMessage?: string;
  systemSellerMessage?: string;
  type: TradeMessageType;
  imageUrl?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateMessageDto {
  tradeId: string;
  message: string;
  imageUrl?: string | null;
}
